import React from 'react';
import PropTypes from 'prop-types';
import FormField from './../FormField';
import RemovableRow from './../RemovableRow';
import { formValues } from 'redux-form';
import CurrencySelector from './../CurrencySelector';
import normalizePrice from 'lib/utils/normalizePrice';

const PriceFieldset = formValues({
  currency: 'currency',
  pricing_type: 'pricing_type',
  ticketing_url_type: 'ticketing_url_type'
})(({ member, index, fields, formErrors, currency, currencies, pricing_type }) => (
  <RemovableRow fields={fields} index={index} >
    <div className="col-md-7">
      <FormField
        label={index === 0 ? 'Ticket Description' : null}
        name={`${member}.name`}
        error={formErrors.getIn(['prices', index.toString(), 'name'])}
        component="input"
        type="text"
        className="form-control"
        placeholder="General Admission"
        required
      />
    </div>
    <div className="col-4 col-lg-2">
      <FormField
        label={index === 0 ? 'Price' : null}
        name={`${member}.price`}
        error={formErrors.getIn(['prices', index.toString(), 'price'])}
        component="input"
        type="text"
        className="form-control"
        placeholder={pricing_type === 'registration_required' ? 'FREE' : '15'}
        normalize={normalizePrice}
        inputProps={{disabled: pricing_type === 'registration_required'}}
        required
      />
    </div>
    <div className="col-4 col-lg-2">
      <CurrencySelector
        label={index === 0 ? 'Currency' : null}
        formErrors={formErrors}
        currencies={currencies}
        currency={currency}
        error={formErrors.getIn(['prices', index.toString(), 'currency'])}
        name={`${member}.currency`}
        inputProps={{disabled: pricing_type === 'registration_required'}}
      />
    </div>
  </RemovableRow>
));

PriceFieldset.propTypes = {
  formErrors: PropTypes.object,
  member: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  fields: PropTypes.object.isRequired,
};

export default PriceFieldset;



// WEBPACK FOOTER //
// app/client/bundles/EventSubmission/components/forms/fieldsets/PriceFieldset.jsx